/* eslint-disable no-new */
import '../../../common/privacy/privacy';
import './privacy_page.scss';
import {
  hubEventLoadDispatch,
  sharedHubEventsInit,
} from '../../../common/hub_events/shared_hub_events';
import bodyTopInit from '../../components/body_top/body_top';
import footerInit from '../../components/footer/footer';
import PrivacyGroupsComponent from './privacy_groups';

const main = (): void => {
  sharedHubEventsInit();
  bodyTopInit();
  footerInit();
  new PrivacyGroupsComponent();
  hubEventLoadDispatch();
};

document.addEventListener('DOMContentLoaded', main);
